import "./ProfileList.css"
import React from "react"
import { observer, inject } from "mobx-react"
import UIButton from "./UIButton"
import Profile from "./Profile"

const ProfileList = ({ app }) => {
  return (
    <div className="ProfileList">
      {app.profiles.map((profile, i) => (
        <Profile
          onRemove={() => app.action.removeProfile(i)}
          key={i}
          profile={profile}
        />
      ))}
      {app.profiles.length > 0 ? (
        <UIButton
          style={{ margin: 10 }}
          onClick={() => app.action.prompt(true)}
        >
          Add...
        </UIButton>
      ) : null}
    </div>
  )
}

export default inject(["app"])(observer(ProfileList))



// WEBPACK FOOTER //
// ./src/components/ProfileList.js